import { ApplicationElement, html } from '@crossiety/lit-components';
import '../main_navigation_item/element.js';

import style from './style.lit.css';

/**
 * Element that displays 5 main navigation items.
 *
 * @slot default - For panel content
 *
 * @cssprop --link-text - Link color
 * @cssprop --link-text-hover - Link hover color
 * @cssprop --link-text-active - Link active color
 */

export default class MainNavigationPanel extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  render() {
    return html`
      <nav>
        <slot></slot>
      </nav>
    `;
  }
}

customElements.get('xs-main-nav-panel') ||
  customElements.define('xs-main-nav-panel', MainNavigationPanel);
